import React from 'react';
import classnames from 'classnames';
import { useIntl } from 'react-intl';

import { getUpsellModalContent, shouldAlignContentImageDown, shouldUseAlternateBackgroundImage } from '../helper';
import styles from '../upsell-modal.module.less';

/**
 * @typedef {import('../../../constants/upsell-modal-content-codes').UpsellModalContentCode} UpsellModalContentCode
 */

/**
 * @param {object} props
 * @param {UpsellModalContentCode} props.upsellModalContentCode
 * @param {string} [props.className]
 * @returns {React.JSX.Element}
 */
export const UpsellModalImage = ({ upsellModalContentCode, className }) => {
  const intl = useIntl();
  const content = getUpsellModalContent(upsellModalContentCode);
  const imgSrc = content.upsellImageUri;
  const { name } = content;
  const shouldAlignBottom = shouldAlignContentImageDown(upsellModalContentCode);
  const shouldUseAltBackground = shouldUseAlternateBackgroundImage(upsellModalContentCode);

  return (
    <div
      className={classnames(
        styles['image-wrapper'],
        { [styles['align-bottom']]: shouldAlignBottom },
        { [styles['alt-background']]: shouldUseAltBackground },
        className,
      )}
    >
      {imgSrc ? <img alt={intl.formatMessage(name)} src={imgSrc} /> : null}
    </div>
  );
};
